import React from 'react';

import {Table,ButtonGroup,Button} from 'react-bootstrap';
import Criteria from './components/Criteria';


const SegmentsTable = (props) => {
    const {segments} = props;
    const nonCriteriaParams = ['id','name','total','subscribed','unsubscribed'];

    const rows = segments.map(segment => {
        const {id,name,total,subscribed,unsubscribed} = segment;
        const criterias = Object.keys(segment).map(param => {
            let value = segment[param];

            if(param === 'countries' && value) value = value.join(',');

            if((value || value === 0) && !nonCriteriaParams.includes(param)) {
                return <Criteria name={param} value={value} key={param}/>;
            }

            return '';
        });

        return (
            <tr key={id}>
                <td>{id}</td>
                <td>{name}</td>
                <td>{criterias}</td>
                <td>{total}</td>
                <td>{subscribed}</td>
                <td>{unsubscribed}</td>
                <td>
                    <ButtonGroup>
                        <Button bsStyle="info" onClick={() => props.onUpdateBtnClick(id)}>Update</Button>
                        <Button bsStyle="info" onClick={() => props.onDuplicateBtnClick(id)}>Duplicate</Button>
                        <Button bsStyle="danger" onClick={() => props.onRemoveBtnClick(id)}>Remove</Button>
                    </ButtonGroup>
                </td>
            </tr>
        );
    });

    return (
        <Table bordered responsive>
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Criteria</th>
                    <th>Total</th>
                    <th>Subscribed</th>
                    <th>Unsubscribed</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    );
}

export default SegmentsTable;


// WEBPACK FOOTER //
// ./src/scenes/Segments/components/SegmentsTable/index.js